<template>
  <el-dialog
    :title="drawer.title"
    :visible.sync="drawer.show"
    :append-to-body="true"
    width="1000px"
    :before-close="handleClose"
  >
    <div>
      <el-form ref="ruleForm" :inline="true" :model="agency" :rules="rules" class="drawer-from" label-width="80px" label-position="right">
        <el-form-item label="企业名称" prop="name">
          <el-input v-model="agency.name" clearable placeholder="输入企业名称" size="small" />
        </el-form-item>
        <el-form-item label="X值" prop="x">
          <el-input v-model="agency.x" type="number" clearable placeholder="输入X值" size="small" />
        </el-form-item>
        <el-form-item label="Y值" prop="y">
          <el-input v-model="agency.y" type="number" clearable placeholder="输入Y值" size="small" />
        </el-form-item>
        <el-form-item label="标准值" prop="standard">
          <el-input v-model="agency.standard" type="number" clearable placeholder="输入标准值" size="small" />
        </el-form-item>
        <el-form-item label="先进值" prop="advanced">
          <el-input v-model="agency.advanced" type="number" clearable placeholder="输入先进值" size="small" />
        </el-form-item>
        <el-form-item label="能耗单位">
          <el-input v-model="agency.useUnit" clearable placeholder="输入产值能耗单位" size="small" />
        </el-form-item>
      </el-form>
      <div class="energy-table">
        <div class="wh-title-one">
          能耗统计
        </div>
        <el-table
          :data="tableData"
          class="input-table"
        >
          <el-table-column
            label="总耗能"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.all" size="small" @input="tableInputFn" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="电力"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.electric" size="small" @input="tableInputFn" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="天然气"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.gas" size="small" @input="tableInputFn" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="煤炭"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.coal" size="small" @input="tableInputFn" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="其他"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="input-box">
                <el-input v-model="scope.row.other" size="small" @input="tableInputFn" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-row :gutter="40">
        <el-col class="unit-table" :span="12">
          <div class="wh-title-one m-top">
            单位产值能耗
          </div>
          <el-table
            :data="unitData"
            height="220"
            class="input-table"
          >
            <el-table-column
              label="年份"
              min-width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div class="input-box">
                  <el-input v-model="scope.row.date" size="small" />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="数值"
              min-width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div class="input-box">
                  <el-input v-model="scope.row.num" size="small" />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="120"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div class="txt-box">
                  <el-button type="danger" size="mini" @click="deleteData(scope.$index)">
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-button class="add-btn" size="mini" @click="addData">
            增加一列
          </el-button>
        </el-col>
        <el-col class="unit-table" :span="12">
          <div class="wh-title-one m-top">
            单位产品能耗
          </div>
          <el-table
            :data="productData"
            height="220"
            class="input-table"
          >
            <el-table-column
              label="年份"
              min-width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div class="input-box">
                  <el-input v-model="scope.row.date" size="small" />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="数值"
              min-width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div class="input-box">
                  <el-input v-model="scope.row.num" size="small" />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="120"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div class="txt-box">
                  <el-button type="danger" size="mini" @click="deleteData1(scope.$index)">
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-button class="add-btn" size="mini" @click="addData1">
            增加一列
          </el-button>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="sureFn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { deepCopy, mergeArrToObj } from '@/utils/tool'
export default {
  name: 'AgencyDrawer',
  props: {
    drawer: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      agency: {
        name: '',
        x: '',
        y: '',
        standard: '',
        advanced: '',
        useUnit: ''
      },
      tableData: [],
      unitData: [],
      productData: [],
      rules: {
        name: [{ required: true, message: '请输入企业名称', trigger: 'change' }],
        x: [{ required: true, message: '请输入X值', trigger: 'change' }],
        y: [{ required: true, message: '请输入Y值', trigger: 'change' }],
        standard: [{ required: true, message: '请输入标准值', trigger: 'change' }],
        advanced: [{ required: true, message: '请输入先进值', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapState([
      'curAgency'
    ])
  },
  watch: {
    curAgency: {
      handler(newV, oldV) {
        this.agency = { ...this.agency, ...deepCopy(newV) }
        const keyList = ['all', 'electric', 'gas', 'coal', 'other']
        const itemList = newV.energyUseStatistics || [0, 0, 0, 0, 0]
        this.tableData = [mergeArrToObj(keyList, itemList)]
        this.unitData = newV.unitOutputDate.map((item, index) => ({
          date: item,
          num: newV.unitOutputNum[index] || 0
        }))
        this.productData = newV.unitProductDate.map((item, index) => ({
          date: item,
          num: newV.unitProductNum[index] || 0
        }))
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleClose(done) {
      done()
    },
    tableInputFn() {},
    deleteData(index) {
      this.unitData.splice(index, 1)
    },
    addData() {
      this.unitData.push({
        date: '',
        num: 0
      })
    },
    deleteData1(index) {
      this.productData.splice(index, 1)
    },
    addData1() {
      this.productData.push({
        date: '',
        num: 0
      })
    },
    sureFn() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const temp = {
            name: this.agency.name,
            x: this.agency.x,
            y: this.agency.y,
            standard: this.agency.standard,
            advanced: this.agency.advanced,
            useUnit: this.agency.useUnit,
            energyUseStatistics: [this.tableData[0].all, this.tableData[0].electric, this.tableData[0].gas, this.tableData[0].coal, this.tableData[0].other],
            energyProportion: [this.tableData[0].electric, this.tableData[0].gas, this.tableData[0].coal, this.tableData[0].other],
            unitOutputDate: this.unitData.map(item => item.date),
            unitOutputNum: this.unitData.map(item => item.num),
            unitProductDate: this.productData.map(item => item.date),
            unitProductNum: this.productData.map(item => item.num)
          }
          this.$emit('sure', temp)
        } else {
          this.$message.warning('请补全表单必填项')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .txt-box{
    text-align: center;
    color: #fff;
  }
  .unit-table, .energy-table{
    text-align: right;
    /deep/ .el-table::before{
      height: 0!important;
    }
    /deep/ td{
      border-bottom: 1px solid transparent!important;
    }
    .add-btn{
      margin-top: 10px;
    }
  }
  /deep/ .el-dialog{
    .el-dialog__body{
      padding: 10px 50px;
    }
  }
  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  /deep/ input[type='number'] {
    -moz-appearance: textfield;
  }
  .drawer-from{
    /deep/ .el-input__inner{
      width: 200px;
    }
  }
</style>
